import { createStore } from 'redux'
import loggedInUserReducer from './loggedInUserReducer'
import { combineReducers } from 'redux';


const rootReducer = combineReducers({user:loggedInUserReducer});
const store = createStore(rootReducer)

export default store